import "core-js/modules/es6.array.find.js";
export default {
  total: function total(state) {
    return state.total;
  },
  items: function items(state) {
    return state.items;
  },
  success: function success(state) {
    return state.success;
  },
  successServer: function successServer(state) {
    return state.successServer;
  },
  state: function state(_state) {
    return _state.cartState;
  },
  referenceQuantity: function referenceQuantity(state) {
    return function (reference) {
      var _state$items$find$qua, _state$items, _state$items$find;
      return (_state$items$find$qua = (_state$items = state.items) === null || _state$items === void 0 ? void 0 : (_state$items$find = _state$items.find(function (_ref) {
        var productReference = _ref.productReference;
        return productReference === reference;
      })) === null || _state$items$find === void 0 ? void 0 : _state$items$find.quantity) !== null && _state$items$find$qua !== void 0 ? _state$items$find$qua : 0;
    };
  }
};